
export const extractFormData = (form) => {
    const formData = new FormData(form);
    const formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });
    return formDataObject;
  };